import React from 'react';
import { getDiceEntryRenderState, resolveFaceOverride } from './dice.logic';
import { DiceResultBadge, SourceAvatar, renderRollToken } from './dice.ui';

export const DiceDisplayLast = ({
  history,
  historyLimit,
  animByRollKey,
  newestKey,
  lastSeenRollKey,
  mountedAt,
  animationMs,
  buttons,
  items,
  contextItem,
  item,
}) => {
  if (!(historyLimit > 0 && history.length > 0)) {
    return (
      <div className='h-full w-full flex items-center justify-center text-xs text-contrast text-opacity-40'>
        aucun lancer
      </div>
    );
  }

  const h = history[0];
  const rollKey = h?.rollId || h?.at || null;
  const anim = rollKey ? animByRollKey?.[rollKey] : null;
  const vm = getDiceEntryRenderState({
    entry: h,
    anim,
    now: Date.now(),
    newestKey,
    lastSeenRollKey,
    mountedAt,
    animationMs,
    buttons,
    items,
    contextItem,
    item,
  });

  return (
    <div className='h-full w-full flex items-center justify-center'>
      <div className='w-full flex flex-col items-center justify-center gap-05'>
        <div className='font-condensed text-contrast text-opacity-90 leading-none'>
          {vm.displayMode === 'each' &&
          (Array.isArray(vm.animRolls) ||
            (Array.isArray(vm.rolls) && vm.rolls.length > 1)) ? (
            <span className='flex items-center gap-03 flex-wrap justify-center'>
              {(vm.animRolls || vm.rolls || []).map((r, rIdx) => {
                const tokenFace = resolveFaceOverride(vm.buttonConfig, r);
                const key = `${vm.rollKey || 'r'}-${rIdx}`;
                return (
                  <React.Fragment key={key}>
                    {rIdx > 0 && (
                      <span className='text-contrast text-opacity-30 text-3xl'>
                        +
                      </span>
                    )}
                    {renderRollToken(r, tokenFace, item, key, {
                      faceSize: 44,
                      textClassName: 'text-4xl',
                    })}
                  </React.Fragment>
                );
              })}
            </span>
          ) : Number.isFinite(vm.value) ? (
            renderRollToken(vm.value, vm.face, item, vm.rollKey, {
              faceSize: 56,
              textClassName: 'text-4xl',
            })
          ) : (
            '-'
          )}
        </div>

        <DiceResultBadge
          label={vm.resultLabel}
          iconSlug={vm.resultIconSlug}
          color={vm.resultColor}
          description={vm.resultDescription}
          itemId={vm.fromItemId || item?._id || null}
          textId={`${vm.rollKey || h?.at || 'last'}-result`}
          className='px-03 py-02'
        />

        <div className='flex gap-1 items-center justify-center'>
          <SourceAvatar
            item={items[vm.fromItemId]}
            tooltip={vm.fromItemLabel || ''}
          />
          {vm.buttonLabel && (
            <div className='text-xs text-contrast text-opacity-40'>
              ({vm.buttonLabel})
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
